import {
  CircledIcon,
  FlagIcon,
  Mtds,
  SamplesView,
  ScreenHeader,
  TopBar,
  AppLayout
} from 'prove-common'
import { useSamples } from '../hooks/useSamples'
import { AppLogo } from '../components/app-logo/AppLogo'
import { SideBar } from '../components/side-bar/SideBar'

export const SamplesToProcessScreen = () => {
  const params = new URLSearchParams(globalThis.location.search)
  const userId = params.get('userId') || undefined
  const ownerId = params.get('ownerId') || undefined
  const { filteredSamples, hasNextPage, ownerName, isPending, isError } =
    useSamples({
      filters: {
        planIds: [],
        productIds: [],
        matrixIds: [],
        sampntTypeIds: [],
        substanceIds: [],
        status: ['ReadyToProcess'],
        userId,
        ownerId
      },
      activePlan: undefined,
      isEnabled: true
    })

  const loaderContent = hasNextPage ? (
    <Mtds.Skeleton />
  ) : (
    'Det er ingen fler prøver å laste inn'
  )

  const numberOfSamplesReadyToProcess = filteredSamples?.length

  const breadcrumbItems = [
    {
      label: 'Hjem',
      to: '/home'
    },
    {
      label: 'Nye prøvesvar'
    }
  ]

  return (
    <AppLayout
      topBar={<TopBar logo={<AppLogo />} breadcrumbItems={breadcrumbItems} />}
      sidebar={<SideBar />}
      isLoading={isPending && !isError}
      isError={isError}
    >
      <Mtds.Grid data-justify='center' data-color='danger'>
        <CircledIcon icon={<FlagIcon />} />
        <ScreenHeader
          title={`${numberOfSamplesReadyToProcess} ${numberOfSamplesReadyToProcess === 1 ? 'prøve klar' : 'prøver klare'} til behandling`}
        />
        <Mtds.Heading as='h2' data-size='xs'>
          {ownerId != null && ownerName?.name}
          {userId != null && 'For deg'}
        </Mtds.Heading>
      </Mtds.Grid>
      <SamplesView
        mode='card'
        samples={filteredSamples}
        loaderContent={loaderContent}
      />
    </AppLayout>
  )
}
